import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { SortableList } from "shared/SortableList";
import { SortableItem } from "shared/SortableItem";
import LessonPartCard from "./LessonPartCard";
import { emptyPart } from "../types";
import { useSortableFieldArray } from "../hooks/useSortableFieldArray";

const PartsSection: React.VFC = () => {
  // No part delete yet — the backend doesn't expose a DELETE for lesson parts,
  // so omit onRemove below rather than offer a control that can't round-trip.
  const { ids, fields, onDragEnd, append } = useSortableFieldArray("parts");

  return (
    <Box mt={3}>
      <Box display="flex" alignItems="center" mb={1} style={{ gap: 8 }}>
        <Typography variant="h5">Parts</Typography>
        <Button size="small" startIcon={<Add />} onClick={() => append(emptyPart())}>
          Add part
        </Button>
        <Typography variant="caption" color="textSecondary">
          (Can't be deleted)
        </Typography>
      </Box>
      <SortableList items={ids} onDragEnd={onDragEnd}>
        {fields.map((f, i) => (
          <SortableItem key={ids[i]} id={ids[i]} accordion label={`Part ${i + 1}`}>
            <LessonPartCard partIndex={i} />
          </SortableItem>
        ))}
      </SortableList>
    </Box>
  );
};

export default PartsSection;
